import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Container, Grid, Typography, Box,
} from '@mui/material';
import { useTranslation } from 'next-i18next';

import GetStartedBtn from 'views/RentMyMotorcycleView/components/GetStartedBtn';

const PREFIX = 'ReadyToEarn';

const classes = {
  greyBG: `${PREFIX}-greyBG`,
  mainContainer: `${PREFIX}-mainContainer`,
  imgGrid: `${PREFIX}-imgGrid`,
  txtGrid: `${PREFIX}-txtGrid`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  getStartedBox: `${PREFIX}-getStartedBox`,
  imgContainer: `${PREFIX}-imgContainer`,
  img: `${PREFIX}-img`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.greyBG}`]: {
    backgroundColor: theme.palette.grey.A000,
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },

  [`& .${classes.mainContainer}`]: {
    marginTop: theme.spacing(8.125),
    paddingBottom: theme.spacing(13),
    maxWidth: theme.spacing(166.25),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(12.5),
      paddingBottom: theme.spacing(6.25),
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(3.75),
      paddingBottom: theme.spacing(6.5),
    },
  },

  [`& .${classes.imgGrid}`]: {
    [theme.breakpoints.up('lg')]: {
      order: 2,
    },
  },

  [`& .${classes.txtGrid}`]: {
    [theme.breakpoints.up('lg')]: {
      order: 1,
      paddingLeft: `${theme.spacing(5.75)} !important`,
    },
  },

  [`& .${classes.title}`]: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(50),
      fontWeight: '500',
      marginBottom: theme.spacing(4.5),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
      marginBottom: theme.spacing(2.75),
      marginTop: theme.spacing(-8.75),
    },
  },

  [`& .${classes.subTitle}`]: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(22),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
    },
  },

  [`& .${classes.getStartedBox}`]: {
    marginTop: theme.spacing(4.5),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6.25),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
      marginTop: theme.spacing(5),
    },
  },

  [`& .${classes.imgContainer}`]: {
    textAlign: 'center',
    marginBottom: theme.spacing(6.25),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(9),
    },
  },

  [`& .${classes.img}`]: {
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '85%',
    },
  },
}));

const ReadyToEarn = () => {
  const { t } = useTranslation('fe_er_rent_my_motorcycle');

  return (
    <Root>
      <Box className={classes.greyBG}>
        <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}>
            <Grid item xs={12} lg={6} classes={{ item: classes.imgGrid }}>
              <Box className={classes.imgContainer}>
                <img
                  className={classes.img}
                  src="/imgs/list-your-bike/ready_to_earn.svg"
                  alt={t('fe_er_rent_my_motorcycle:ready_to_earn')}
                />
              </Box>
            </Grid>
            <Grid item xs={12} lg={6} classes={{ item: classes.txtGrid }}>
              <Typography variant="h2" classes={{ root: classes.title }}>
                {t('fe_er_rent_my_motorcycle:ready_to_earn')}
              </Typography>
              <Typography variant="h3" classes={{ root: classes.subTitle }}>
                {t('fe_er_rent_my_motorcycle:join_community')}
              </Typography>
              <Box className={classes.getStartedBox}>
                <GetStartedBtn t={t} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Root>
  );
};

export default ReadyToEarn;
